import Vue from 'vue';
import Posts from '../vue/Posts.vue';

if(document.getElementById('posts')){
	new Vue({
		el: '#posts',
		components: {
			'posts': Posts
		}
	})
}